import { TemplateElement, html, defineElement } from '@webtides/element-js';

class ShowMore extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }

    connected() {
        super.connected();
        this.removeAttribute('cloak');
    }

    properties() {
        return {
            selector: '',
            quantity: 6,
            initial: 6,
        };
    }

    events() {
        return {
            '[data-show-more]': {
                click: (e) => {
                    e.preventDefault();
                    this.showMore();
                },
            },
        };
    }

    showMore(quantity = this.quantity) {
        let elements = this.querySelectorAll(`${this.selector}.hidden`);
        elements.forEach((element, index) => {
            if (index < quantity) {
                element.classList.remove('hidden');
            }
        });

        if (elements.length <= this.quantity) {
            this.$refs.action.classList.add('hidden');
        } else {
            this.$refs.action.classList.remove('hidden');
        }
    }

    template() {
        return html`
            <slot></slot>
            <slot name="action" data-show-more ref="action"></slot>
        `;
    }
}

export function define() {
    defineElement('show-more', ShowMore);
}
